import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';

// com-item
import BaseForm from './basic-form/basic-form.vue';
import FundForm from './fund-form/fund-form.vue';
import ExplainForm from './explain-form/explain-form.vue';

export default {
  components: {
    ProcessNavigation,
    BaseForm,
    FundForm,
    ExplainForm
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      id: '',
      isCreated: true,
      projectInfo: {}
    };
  },
  computed: {
    ...mapGetters({
      processList: 'purchaseProcessList'
    })
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    if (this.id || this.oldId) {this.getPurchaseInfo();}
  },
  methods: {
    // 项目信息回显
    getPurchaseInfo() {
      this.$store.dispatch('getPurchaseInfo', {purchaseId: this.id || this.oldId, echoCode: 'PURCHASE'}).then(res => {
        if (!res.data) {
          return;
        }
        // res.data.purchaseBudget = res.data.purchaseBudget / 10000;
        this.projectInfo = res.data;
        if (this.oldId && !this.id) {
          this.isCreated = true;
        } else {
          this.isCreated = false;
        }
      });
    },
    // 编辑项目信息
    updateProjectInfo (obj) {
      this.$store.dispatch('updatePurchaseInfo', {...obj, purchaseId: this.id}).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push(`/publish-purchase/eligibility-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${obj.projectType}`);
          } else {
            this.$router.push(`/publish-purchase/eligibility-form?id=${this.id}&projectTypeOfPur=${obj.projectType}`);
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      });
    },
    // 保存项目信息
    saveProjectInfo(params) {
      // 重新申请带上oldId
      if (this.oldId) {
        params.oldId = this.oldId;
      }
      this.$store.dispatch('savePurchaseInfo', params).then(res => {
        if (res && res.code === '0') {
          this.id = res.data;
          if (this.oldId) {
            this.$router.push(`/publish-purchase/eligibility-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${params.projectType}` );
          } else {
            this.$router.push(`/publish-purchase/eligibility-form?id=${this.id}&projectTypeOfPur=${params.projectType}`);
          }
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      }, (error) => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      });
    },
    // 上一步
    previousStep () {
      let str = '';
      if (this.id && this.oldId) {
        str = '?id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '?id=' + this.id;
      } else if (this.oldId) {
        str = '?oldId=' + this.oldId;
      }
      this.$router.replace('/publish-purchase/publisher-info' + str);
    },
    // 下一步
    next() {
      Promise.all([this.$refs['basicForm'].test(), this.$refs['fundForm'].test(), this.$refs['explainForm'].test()]).then(res => {
        let obj = {
          ...res[0],
          ...res[1],
          ...res[2]
        };
        Object.keys(obj).forEach(key => {
          if (obj[key] === '') {delete obj[key];};
        });
        obj.fundsInfo = obj.fundsInfo.filter(v => v.fundsSource !== '' );
        if (this.isCreated) {
          this.saveProjectInfo(obj);
        } else {
          this.updateProjectInfo(obj);
        }
      }, (error) => {
        console.log(error);
      });
    }
  }
};
